<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs :pt-5="$vuetify.breakpoint.lgAndUp">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-center pt-5 pb-10>
            <v-flex xs12 lg10>
              <v-card class="rounded-lg pt-7">
                <center>
                  <img
                    class="logo-cmp"
                    :src="require('@/assets/img/logoINETCMP.png')"
                    width="400"
                    alt=""
                  />
                </center>
                <v-card-text class="black--text" style="font-size: 16px">
                  <v-layout                  
                    row
                    wrap
                    justify-center
                    align-center
                    pt-4
                    pb-7
                  >
                    <v-flex xs12 lg11 pb-7>
                      <p class="pt-5"><b>หมายเลขกลุ่มความยินยอม : </b> {{ GroupId }}</p>
                      <v-card outlined>
                        <v-card-text
                          class="black--text"
                          style="font-size: 16px"
                        >
                        <p>
                          <b class="pb-2" style="font-size: 22px"
                            >รายละเอียดกลุ่มความยินยอม
                          </b>
                        </p>
                        <p><b>องค์กร : </b> {{ BusinessNameTh }}</p>
                        <p><b>สร้างโดย : </b> {{ UpdatdeBy }}</p>
                        <p><b>อายุเอกสาร (ปี) : </b> {{ ExpireIn }}</p>
                        <v-flex xs11 lg11 pb-3>
                          <b>ข้อมูลที่ต้องการขอ :</b>
                          <v-chip 
                            small
                            style="border: 1px solid"
                            v-for="(item, i) in itemsRequestTag"
                            :key="i"
                            class="ma-1"
                            label
                            text-color="#077893"
                            color="#ddf7ff"
                          >
                            <b>{{ item }}</b>
                          </v-chip>
                        </v-flex> 
                        <p><b>ชื่อกลุ่มความยินยอม : </b> {{ GroupName }}</p>
                        <p><b>รายละเอียดกลุ่มความยินยอมแบบย่อ : </b> {{ Title }}</p>
                        <v-flex xs11 lg11
                          ><b class="mr-2">{{ $t("dashboard.policy") }} :</b>
                          <a v-on:click="Fn_DetailPolicy">{{ PolicyTitle }} </a>
                        </v-flex>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex  xs12 lg11 pb-1>
                      <v-card outlined>
                        <v-card-text>
                          <b>ความยินยอม : </b>
                          <v-card  xs12 lg11 pb-3 v-for="(item, index) in Consent" :key="index" style="display: inline">
                            <v-card color="#ddf7ff" class="elevation-0 ma-3" @click="fn_DetailConsent(item)">
                              <v-card-text>
                                <v-layout row wrap align-center>
                                  <v-flex xs10 lg10 text-left>
                                    <b> {{ item.Title }} </b>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </v-card>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    pt-4
                    pb-7
                    v-if="NameBtnSave == 'อนุมัติกลุ่มความยินยอม'"
                  >
                    <v-flex xs7 sm7 md2 lg2>
                      <v-btn :loading="load" 
                      color="#077893" 
                      dark 
                      block 
                      @click="Fn_Save"
                      >
                        {{ NameBtnSave }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout 
                    row
                    wrap
                    justify-center
                    align-self-center
                    pb-4 
                    v-else
                  >
                    <v-flex xs12 lg4 pt-4>
                      <v-alert border="left" dense text type="success">
                        {{ NameBtnSave }}
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogGeneralConsent
        :show="DialogGeneral"
        :_header="PolicyTitle"
        :_detail="PolicyDetails"
        @closeDialogDelete="DialogGeneral = false"
      />
      <v-dialog v-model="dialogConsent" width="1200" scrollable persistent>
      <v-divider></v-divider>
      <v-card>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <b>ความยินยอม: </b>{{ DetailsConsent.Title }}
          <br />
          <br />
          <v-card color="#ddf7ff">
            <v-card-title>รายละเอียดหากยินยอม</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="DetailsConsent.DetailsConsent"></div>
            </v-card-text>
          </v-card>
          <br />
          <v-card color="#ddf7ff">
            <v-card-title>รายละเอียดหากไม่ยินยอม</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="DetailsConsent.RejectReason"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" outlined @click="dialogConsent = false">
            {{ $t("upload.text6") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
import DialogGeneralConsent from "@/components/dialog/DialogGeneralConsentDetail.vue";
import Layout from '../../../components/layouts/Layout'
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {
    DialogGeneralConsent, Layout, OverlaySearch },
  data: function () {
    return {
      load: false,
      loadingDownloadData: false,
      valid: true,
      ChatAccountId: "",
      dialogConsent: false,
      AccountId: "",
      GroupId: "",
      BusinessNameTh: "",
      Title: "",
      GroupName: "",
      UpdatdeBy: "",
      UpdatdeAt: "",
      PolicyId: "",
      PolicyTitle: "",
      PolicyDetails: "",
      Manage: "",
      NameBtnSave: "อนุมัติกลุ่มความยินยอม",
      ShowStatus: true,
      itemsRequestTag: [],
      DetailsConsent :[],
      ExpireIn: "",
      Tag: "",
      Consent: [],
      DialogGeneral: false,
    };
  },
  computed: {
    // ...mapGetters(["DataGroupConsent"]),
    // ...mapGetters(["Business"]),
    // ...mapGetters(["RoleAccount"]),
    // _RoleAccount: {
    //   get() {
    //     return this.RoleAccount || "-";
    //   },
    // },
    // _SendId: {
    //   get() {
    //     return this.DataGroupConsent.SendId || "-";
    //   },
    // },
  },
  mounted() {
    this.Fn_GetToken();
  },
  methods: {
    async Fn_GetToken() {
      this.loadingDownloadData = true;
      var payload = {
        ShareToken: this.$route.path.split("/")[4],
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "token/login",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.AccessToken = response.data.Message.OneAccessToken;
            this.ChatAccountId = response.data.Message.OneAccountId;
            this.$cookies.set("ChatAccountId", response.data.Message.OneAccountId);
            this.Fn_getDataConsent();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async fn_DetailConsent(item) {
      this.DetailsConsent = item;
      this.dialogConsent = true;
    },

    async Fn_getDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$route.path.split("/")[2],
        GroupId: this.$route.path.split("/")[3],
        AccessToken: this.AccessToken,
      };
      var Headers = {
        AccountId: this.ChatAccountId,
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "group-consent/GetGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.DataGroupConsent = response.data.Message;
            this.GroupId = this.DataGroupConsent.GroupId;
            this.AccountId = this.DataGroupConsent.AccountId;
            this.BusinessNameTh = this.DataGroupConsent.BusinessNameTh;
            this.GroupName = this.DataGroupConsent.GroupName;
            this.Title = this.DataGroupConsent.Title;
            this.Tag = this.DataGroupConsent.Tag;
            this.UpdatdeBy = this.DataGroupConsent.UpdatdeBy;
            this.UpdatdeAt = this.DataGroupConsent.UpdatdeAt;
            this.Manage = this.DataGroupConsent.Manage;
            this.ExpireIn = this.DataGroupConsent.ExpireIn;
            this.PolicyTitle = this.DataGroupConsent.Policy.PolicyTitle;
            this.PolicyDetails = this.DataGroupConsent.Policy.Details;
            this.PolicyId = this.DataGroupConsent.Policy.PolicyId;
            this.Consent = this.DataGroupConsent.Consent;
            this.Policy = this.DataGroupConsent.Policy;
            if (this.Manage == "enable") {
              this.NameBtnSave = "กลุ่มความยินยอมนี้ได้ทำการอนุมัติเรียบร้อยแล้ว";
              this.ShowStatus = false;
            } else {
              this.NameBtnSave = "อนุมัติกลุ่มความยินยอม";
              this.ShowStatus = true;
            }
            var FixArrayTag = this.Tag;
            if (FixArrayTag == "") {
            } else {
              this.itemsRequestTag = FixArrayTag.split(",").map((item) => item.trim());

            }
          } else {
            window.close();
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          window.close();
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Save() {
      this.load = true;
      var payload = {
        AccessToken: this.AccessToken,
        BusinessId: this.$route.path.split("/")[2],
        GroupId: this.$route.path.split("/")[3],
        GroupName: this.GroupName,
        AccountId: this.AccountId,
        PolicyId: this.Policy.PolicyId,
        Tag: this.Tag,
        ExpireIn: this.ExpireIn,
        Title: this.Title,
        Consent: this.Consent,
        Manage: "enable"
      };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "group-consent/UpdateDetailGroupConsent",
          payload
        )
        .then((response) => {
          this.load = false;
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.NameBtnSave = "คุณได้อนุมัติกลุ่มความยินยอมเรียบร้อยแล้ว";
            this.ShowStatus = false;
            this.Fn_getDataPolicy();
            Toast.fire({
              icon: "success",
              title: "อนุมัติกลุ่มความยินยอมสำเร็จ",
            });
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.load = false;
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Cancle() {
      window.close();
      this.$refs.formData.reset();
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
  },
  watch: {},
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
